import { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const LoginPage = () => {
  const { login, isAuthenticated, user } = useAuth();
  const navigate = useNavigate();
  const [form, setForm]   = useState({ identifier: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const redirectByRole = (role) => {
    if (role === 'super_admin') navigate('/admin/super', { replace: true });
    else if (role === 'dealer') navigate('/dealer/dashboard', { replace: true });
    else navigate('/admin/events', { replace: true });
  };

  // Auto-login: if already authenticated, redirect to appropriate page
  useEffect(() => {
    if (!isAuthenticated || !user) return;
    const storedPwd = localStorage.getItem('ep_password');
    if (storedPwd === '1234') { navigate('/change-password', { replace: true }); return; }
    redirectByRole(user.role);
  }, [isAuthenticated, user]); // eslint-disable-line

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const userData = await login(form.identifier.trim(), form.password);
      if (form.password === '1234') {
        navigate('/change-password', { replace: true });
      } else {
        redirectByRole(userData.role);
      }
    } catch (err) {
      setError(err.response?.data?.error || 'Invalid credentials. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={s.page}>
      <div style={s.card}>
        <div style={s.header}>
          <div style={s.logo}>📸</div>
          <h1 style={s.title}>Event Photos</h1>
          <p style={s.subtitle}>Sign in to your account</p>
        </div>

        <form onSubmit={handleSubmit} style={s.form}>
          <div style={s.field}>
            <label style={s.label}>Mobile Number or Email</label>
            <input
              style={s.input}
              type="text"
              placeholder="9876543210  or  email@example.com"
              value={form.identifier}
              onChange={e => setForm(f => ({ ...f, identifier: e.target.value }))}
              autoComplete="username"
              required
            />
          </div>
          <div style={s.field}>
            <label style={s.label}>Password</label>
            <input
              style={s.input}
              type="password"
              placeholder="••••••••"
              value={form.password}
              onChange={e => setForm(f => ({ ...f, password: e.target.value }))}
              autoComplete="current-password"
              required
            />
          </div>

          {error && <div style={s.error}>{error}</div>}

          <button type="submit" disabled={loading}
            style={{ ...s.btn, ...(loading ? s.btnDisabled : {}) }}>
            {loading ? 'Signing in…' : 'Sign In'}
          </button>
        </form>

        <div style={s.links}>
          <Link to="/forgot-password" style={s.link}>Forgot password?</Link>
          <span style={s.dot}>·</span>
          <Link to="/signup" style={s.link}>Photographer sign up</Link>
          <span style={s.dot}>·</span>
          <Link to="/dealer/signup" style={s.link}>Dealer sign up</Link>
        </div>
      </div>
    </div>
  );
};

const s = {
  page: { minHeight: '100vh', background: 'linear-gradient(135deg, #1a1a2e 0%, #0f3460 100%)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: "'Segoe UI', system-ui, sans-serif", padding: '1rem' },
  card: { background: '#fff', borderRadius: '1.5rem', padding: '2.5rem', width: '100%', maxWidth: '420px', boxShadow: '0 20px 60px rgba(0,0,0,0.3)' },
  header: { textAlign: 'center', marginBottom: '2rem' },
  logo: { fontSize: '2.5rem', marginBottom: '0.5rem' },
  title: { fontSize: '1.75rem', fontWeight: '800', color: '#1a1a2e', margin: '0 0 0.25rem' },
  subtitle: { color: '#888', margin: 0, fontSize: '0.9rem' },
  form: { display: 'flex', flexDirection: 'column', gap: '1.25rem' },
  field: { display: 'flex', flexDirection: 'column', gap: '0.4rem' },
  label: { fontSize: '0.75rem', fontWeight: '700', color: '#555', textTransform: 'uppercase', letterSpacing: '0.05em' },
  input: { padding: '0.75rem 1rem', border: '1.5px solid #e5e7eb', borderRadius: '0.75rem', fontSize: '1rem', outline: 'none', transition: 'border-color 0.2s' },
  error: { background: '#fef2f2', border: '1px solid #fecaca', borderRadius: '0.5rem', padding: '0.75rem', color: '#dc2626', fontSize: '0.875rem' },
  btn: { padding: '0.875rem', background: 'linear-gradient(135deg, #1a1a2e, #0f3460)', color: '#fff', border: 'none', borderRadius: '0.75rem', fontWeight: '700', fontSize: '1rem', cursor: 'pointer' },
  btnDisabled: { opacity: 0.6, cursor: 'not-allowed' },
  links: { marginTop: '1.5rem', textAlign: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '0.5rem', flexWrap: 'wrap' },
  link: { color: '#4f46e5', fontSize: '0.85rem', textDecoration: 'none', fontWeight: 600 },
  dot: { color: '#ccc', fontSize: '0.85rem' },
};

export default LoginPage;
